export default __webpack_public_path__ + "static/am-news-sm-0ce8fb6e58958e0891d7cdbc5d0d9439.jpg";